import { TweenLite, Linear } from "gsap";

const initStatsBlock = (): void => {
    document.querySelectorAll('.tv-stats').forEach((block: HTMLElement) => {
        block.querySelectorAll('.tv-stats__number').forEach((number: HTMLElement, i) => {
            const from = number.getAttribute('data-from');
            const to = number.getAttribute('data-to');
            const snap = number.getAttribute('data-snap');
            const decimals = number.getAttribute('data-decimals');

            if (from !== to) {
                const tl = {
                    n: from,
                }

                let s = 1;
                try {
                    s = JSON.parse(snap);
                } catch (e) {
                    try {
                        s = Number(snap);
                    } catch (e) {
                        console.error(e);
                    }
                }

                TweenLite.to(tl, {
                    scrollTrigger: block,
                    n: `+=${to}`,
                    delay: i * .1,
                    snap: {
                        n: s
                    },
                    duration: 1,
                    ease: Linear.easeNone,
                    onUpdate: () => {
                        number.innerText = Number(tl.n).toFixed(Number(decimals));
                    },
                })
            }
        })
    })
}

export default initStatsBlock;